import { translations } from './i18n.js';

// DOM Content Loaded
document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM loaded, initializing components...');

  // Initialize language
  initLanguage();

  // Initialize GSAP first
  initGSAP().then(() => {
    initCarousel();
    initFAQ();
    initForms();
    initParticles();
    initScrollEffects();
    initAnimations();
    initPlatformSlider();
    initCookieBanner();
  }).catch(error => {
    console.error('GSAP initialization failed:', error);
    initCarousel();
    initFAQ();
    initForms();
    initParticles();
    initScrollEffects();
    initPlatformSlider();
    initCookieBanner();
  });
});

// Language initialization
function initLanguage() {
  const savedLang = localStorage.getItem('mineops_lang') || 'en';
  setLanguage(savedLang);

  const langBtns = document.querySelectorAll('.lang-btn');
  langBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const lang = e.target.getAttribute('data-lang');
      setLanguage(lang);
    });
  });
}

function setLanguage(lang) {
  if (!translations[lang]) return;

  // Save preference
  localStorage.setItem('mineops_lang', lang);

  // Update active UI indicator
  const currentLangSpan = document.getElementById('current-lang');
  if (currentLangSpan) {
    currentLangSpan.textContent = lang.toUpperCase();
  }

  // Apply translations
  const elements = document.querySelectorAll('[data-i18n]');
  elements.forEach(el => {
    const key = el.getAttribute('data-i18n');
    const keys = key.split('.');

    // Traverse translation object
    let value = translations[lang];
    for (const k of keys) {
      if (value[k] === undefined) {
        value = null; // Key not found
        break;
      }
      value = value[k];
    }

    if (value) {
      // Use innerHTML if the translation has HTML tags, otherwise textContent
      if (value.includes('<')) {
        el.innerHTML = value;
      } else {
        el.textContent = value;
      }
    }
  });

  // Update placeholders
  const placeholders = document.querySelectorAll('[data-i18n-placeholder]');
  placeholders.forEach(el => {
    const key = el.getAttribute('data-i18n-placeholder');
    const keys = key.split('.');
    let value = translations[lang];
    for (const k of keys) {
      value = value[k];
    }
    if (value) {
      el.setAttribute('placeholder', value);
    }
  });

  // Re-initialize animations if GSAP words are modified
  // Wait for DOM to update
  setTimeout(() => {
    if (typeof gsap !== 'undefined') {
      ScrollTrigger.refresh();
    }
  }, 100);
}

// Initialize GSAP with proper error handling
function initGSAP() {
  return new Promise((resolve, reject) => {
    if (typeof gsap !== 'undefined') {
      console.log('GSAP loaded successfully');

      // Register plugins if available
      if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        console.log('ScrollTrigger registered');
      }

      if (typeof TextPlugin !== 'undefined') {
        gsap.registerPlugin(TextPlugin);
        console.log('TextPlugin registered');
      }

      if (typeof ScrollToPlugin !== 'undefined') {
        gsap.registerPlugin(ScrollToPlugin);
        console.log('ScrollToPlugin registered');
      }

      resolve();
    } else {
      console.warn('GSAP not available, animations will be limited');
      reject(new Error('GSAP not loaded'));
    }
  });
}

// Tab System for Platform Showcase - Ya no se usa para #platform
function initTabSystem() {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');

  if (tabButtons.length === 0 || tabContents.length === 0) return;

  // Set first tab as active by default if none is active
  if (!document.querySelector('.tab-content:not(.hidden)')) {
    tabContents[0]?.classList.remove('hidden');
    tabButtons[0]?.classList.add('bg-blue-600');
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-tab');

      // Update button states
      tabButtons.forEach(btn => {
        btn.classList.remove('bg-blue-600');
        btn.classList.add('bg-gray-800');
      });
      button.classList.remove('bg-gray-800');
      button.classList.add('bg-blue-600');

      // Update tab contents
      tabContents.forEach(content => {
        content.classList.add('hidden');
      });

      const activeTab = document.getElementById(tabId);
      if (activeTab) {
        activeTab.classList.remove('hidden');
      }
    });
  });
}

// Carousel functionality for Features section
function initCarousel() {
  const track = document.querySelector('.carousel-track');
  const slides = document.querySelectorAll('.carousel-slide');
  const dots = document.querySelectorAll('.carousel-dot');
  const prevBtn = document.querySelector('.carousel-button-prev');
  const nextBtn = document.querySelector('.carousel-button-next');

  if (!track || slides.length === 0) return;

  let currentSlide = 0;
  const slideCount = slides.length;

  console.log('Carousel initialized with', slideCount, 'slides');

  // Update carousel position
  function updateCarousel() {
    const translateX = -currentSlide * 50;
    track.style.transform = `translateX(${translateX}%)`;

    // Update dots
    dots.forEach((dot, index) => {
      if (index === currentSlide) {
        dot.classList.add('bg-blue-500');
        dot.classList.remove('bg-gray-600');
      } else {
        dot.classList.remove('bg-blue-500');
        dot.classList.add('bg-gray-600');
      }
    });
  }

  // Next slide
  function nextSlide() {
    currentSlide = (currentSlide + 1) % slideCount;
    updateCarousel();
  }

  // Previous slide
  function prevSlide() {
    currentSlide = (currentSlide - 1 + slideCount) % slideCount;
    updateCarousel();
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      updateCarousel();
    });
  });

  // Auto-advance
  setInterval(nextSlide, 25000);

  // Initialize carousel position
  updateCarousel();
}

// FAQ accordion functionality
function initFAQ() {
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Close all items first
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('active');
        const answer = otherItem.querySelector('.faq-answer');
        const icon = otherItem.querySelector('.faq-icon i');
        if (answer) answer.classList.add('hidden');
        if (icon) {
          icon.classList.remove('bi-chevron-up');
          icon.classList.add('bi-chevron-down');
        }
      });

      // If it wasn't active, open it
      if (!isActive) {
        item.classList.add('active');
        const answer = item.querySelector('.faq-answer');
        const icon = item.querySelector('.faq-icon i');

        if (answer) answer.classList.remove('hidden');
        if (icon) {
          icon.classList.remove('bi-chevron-down');
          icon.classList.add('bi-chevron-up');
        }

        // GSAP animation for FAQ opening
        if (typeof gsap !== 'undefined' && answer) {
          gsap.fromTo(answer,
            { height: 0, opacity: 0 },
            { height: 'auto', opacity: 1, duration: 0.5, ease: 'power2.out' }
          );
        }
      }
    });
  });
}


// Email validation helper
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// GSAP Animations - SOLO UNA VEZ
function initAnimations() {
  console.log('Initializing animations...');

  // Check if GSAP is available
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not available, skipping animations');
    return;
  }

  // Hero Badge Animation
  const heroBadge = document.getElementById('hero-badge');
  if (heroBadge) {
    gsap.from(heroBadge, {
      duration: 1.2,
      y: -50,
      opacity: 0,
      scale: 0.8,
      ease: 'elastic.out(1, 0.5)',
      delay: 0.2
    });
  }

  // Word animations
  const words = document.querySelectorAll('.word');
  const descWords = document.querySelectorAll('.desc-word');

  if (words.length > 0) {
    const heroTimeline = gsap.timeline({ delay: 0.5 });

    // Animate each word with stagger
    heroTimeline.to(words, {
      duration: 0.8,
      opacity: 1,
      y: 0,
      rotateX: 0,
      stagger: {
        amount: 1.2,
        from: "start",
        ease: "power2.out"
      },
      ease: "back.out(1.5)",
      onComplete: () => {
        // Animate the underlines on highlighted words
        gsap.to('.word.highlight::after', {
          opacity: 1,
          duration: 0.6,
          stagger: 0.2,
          ease: "power2.out"
        });
      }
    });

    // Add floating animation to highlighted words
    gsap.to('.word.highlight', {
      y: -5,
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      stagger: 0.3,
      delay: 2
    });
  }

  // Animate description words
  if (descWords.length > 0) {
    gsap.to(descWords, {
      duration: 0.5,
      opacity: 1,
      y: 0,
      stagger: 0.05,
      ease: "power2.out",
      delay: 1
    });
  }

  // Dashboard image entrance
  const dashboardImage = document.getElementById('dashboard-image');
  if (dashboardImage) {
    gsap.from(dashboardImage, {
      duration: 1.5,
      y: 100,
      opacity: 0,
      scale: 0.95,
      ease: 'power3.out',
      delay: 2,
      scrollTrigger: {
        trigger: dashboardImage,
        start: 'top 90%',
      }
    });
  }

  // ScrollTrigger animations
  if (typeof ScrollTrigger !== 'undefined') {

    // Stats container entrance
    const statsContainer = document.querySelector('.stats-container');
    if (statsContainer) {
      gsap.from(statsContainer, {
        scrollTrigger: {
          trigger: statsContainer,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out'
      });
    }

    // Stats counter animation
    const statNumbers = document.querySelectorAll('.stat-number');

    statNumbers.forEach((stat, index) => {
      const originalText = stat.textContent;
      const hasPlus = originalText.includes('+');
      const hasPercent = originalText.includes('%');
      const hasK = originalText.includes('K');
      const hasSlash = originalText.includes('/');

      // Extract the numeric value
      let numericValue = parseFloat(originalText.replace(/[^0-9.]/g, '')) || 0;

      if (!hasSlash) {
        // For numeric values, animate the count
        stat.textContent = hasPlus ? '+0' : '0';

        gsap.to(stat, {
          scrollTrigger: {
            trigger: stat,
            start: 'top 85%',
            end: 'bottom 20%',
            toggleActions: 'play none none reverse'
          },
          duration: 2,
          textContent: numericValue,
          snap: { textContent: 1 },
          ease: 'power2.out',
          delay: index * 0.2,
          onUpdate: function () {
            let displayValue = Math.round(parseFloat(this.targets()[0].textContent));

            if (hasK) {
              displayValue = displayValue + 'K';
            } else if (hasPercent) {
              displayValue = displayValue + '%';
            } else {
              displayValue = displayValue.toString();
            }

            if (hasPlus) {
              displayValue = '+' + displayValue;
            }

            stat.textContent = displayValue;
          }
        });
      }

      // Scale animation for all stats
      gsap.from(stat, {
        scrollTrigger: {
          trigger: stat,
          start: 'top 85%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 0.6,
        scale: 0,
        ease: 'back.out(3)',
        delay: index * 0.2
      });
    });

    // Feature cards animation
    const featureCards = document.querySelectorAll('.feature-card');
    featureCards.forEach(card => {
      gsap.from(card, {
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 0.8,
        y: 60,
        opacity: 0,
        scale: 0.95,
        ease: 'power2.out'
      });

      // Add hover effects
      card.addEventListener('mouseenter', () => {
        gsap.to(card, {
          y: -10,
          duration: 0.3,
          ease: 'power2.out'
        });
      });

      card.addEventListener('mouseleave', () => {
        gsap.to(card, {
          y: 0,
          duration: 0.3,
          ease: 'power2.out'
        });
      });
    });

    // Future cards animation
    const futureCards = document.querySelectorAll('.future-card');
    futureCards.forEach(card => {
      gsap.from(card, {
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 0.8,
        y: 60,
        opacity: 0,
        scale: 0.9,
        ease: 'back.out(1.7)',
        stagger: 0.1
      });
    });

    // FAQ items animation
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
      gsap.from(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 0.6,
        y: 30,
        opacity: 0,
        ease: 'power2.out',
        stagger: 0.1
      });
    });

    // ==========================================================
    // === NUEVO CÓDIGO DE ANIMACIÓN PARA LA SECCIÓN PLATFORM ===
    // ==========================================================

    // Animación de entrada para el título de la sección
    gsap.from(".platform-title", {
      scrollTrigger: {
        trigger: "#platform",
        start: "top 80%",
      },
      opacity: 0, y: 30, duration: 0.6
    });
    gsap.from(".platform-subtitle", {
      scrollTrigger: {
        trigger: "#platform",
        start: "top 80%",
      },
      opacity: 0, y: 30, duration: 0.6, delay: 0.2
    });

    // Selecciona todos los wrappers de imagen y los bloques de texto
    const imageWrappers = gsap.utils.toArray('.platform-image-wrapper');
    const textBlocks = gsap.utils.toArray('.platform-feature-text');

    // Asegurarse de que el primer texto sea visible por defecto
    if (textBlocks.length > 0) {
      gsap.set(textBlocks[0], { opacity: 1, y: 0 });
      gsap.set(textBlocks.slice(1), { opacity: 0, y: 20 });
    }

    imageWrappers.forEach((wrapper, index) => {
      const correspondingText = textBlocks[index];

      // 1. Animación de entrada para cada imagen
      gsap.from(wrapper, {
        scrollTrigger: {
          trigger: wrapper,
          start: "top 80%", // La imagen empieza a aparecer
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        y: 50,
        duration: 0.8,
        ease: 'power3.out'
      });

      // 2. Animación de ScrollTrigger para cambiar el texto
      if (correspondingText) {
        ScrollTrigger.create({
          trigger: wrapper,
          start: "top 40%", // Cuando el 40% superior de la imagen llega al centro
          end: "bottom 40%", // Cuando el 40% inferior de la imagen deja el centro
          // markers: true, // Descomenta para depurar
          onEnter: () => {
            // Oculta todos los textos
            gsap.to(textBlocks, {
              opacity: 0,
              y: -20,
              duration: 0.4,
              ease: 'power2.inOut'
            });
            // Muestra el texto correspondiente
            gsap.to(correspondingText, {
              opacity: 1,
              y: 0,
              duration: 0.4,
              delay: 0.1, // Pequeño retraso para un efecto suave
              ease: 'power2.out'
            });
          },
          onEnterBack: () => {
            // Oculta todos los textos
            gsap.to(textBlocks, {
              opacity: 0,
              y: -20,
              duration: 0.4,
              ease: 'power2.inOut'
            });
            // Muestra el texto correspondiente
            gsap.to(correspondingText, {
              opacity: 1,
              y: 0,
              duration: 0.4,
              delay: 0.1,
              ease: 'power2.out'
            });
          }
        });
      }
    });

    // === FIN DEL NUEVO CÓDIGO ===
    // =============================

  }

  // Button hover animations
  const buttons = document.querySelectorAll('a, button');
  buttons.forEach(button => {
    button.addEventListener('mouseenter', () => {
      gsap.to(button, {
        scale: 1.05,
        duration: 0.2,
        ease: 'power2.out'
      });
    });

    button.addEventListener('mouseleave', () => {
      gsap.to(button, {
        scale: 1,
        duration: 0.2,
        ease: 'power2.out'
      });
    });
  });

  gsap.to(".dotted-path", {
    strokeDashoffset: -390,
    repeat: -1,
    ease: "none",
    duration: 3
  });

  if (typeof ScrollTrigger !== 'undefined') {
    // Animaciones para la sección de racks
    const rackSections = document.querySelectorAll('.bg-gradient-to-br');
    rackSections.forEach((section, index) => {
      gsap.from(section, {
        scrollTrigger: {
          trigger: section,
          start: 'top 85%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 1,
        y: 50,
        opacity: 0,
        scale: 0.95,
        ease: 'back.out(1.7)',
        delay: index * 0.2
      });
    });

    // Animación para las imágenes de racks
    const rackImages = document.querySelectorAll('img[src*="rack"]');
    rackImages.forEach((img, index) => {
      gsap.from(img.parentElement, {
        scrollTrigger: {
          trigger: img.parentElement,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse'
        },
        duration: 1.2,
        y: 100,
        opacity: 0,
        rotationY: 10,
        ease: 'power3.out',
        delay: index * 0.3
      });
    });
  }
}

// Simple particle effect for hero section
function initParticles() {
  const container = document.getElementById('particles');

  if (!container) return;

  const particleCount = 30;

  for (let i = 0; i < particleCount; i++) {
    createParticle(container);
  }

  function createParticle(container) {
    const particle = document.createElement('div');
    particle.classList.add('absolute', 'rounded-full', 'bg-white');

    const size = Math.random() * 3 + 1;
    const posX = Math.random() * 100;
    const posY = Math.random() * 100;

    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.left = `${posX}%`;
    particle.style.top = `${posY}%`;
    particle.style.opacity = Math.random() * 0.3 + 0.1;

    container.appendChild(particle);

    if (typeof gsap !== 'undefined') {
      gsap.to(particle, {
        duration: Math.random() * 10 + 10,
        x: `+=${Math.random() * 100 - 50}`,
        y: `+=${Math.random() * 100 - 50}`,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });

      gsap.to(particle, {
        duration: Math.random() * 5 + 5,
        opacity: Math.random() * 0.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    }
  }
}

// Scroll effects
function initScrollEffects() {
  // Navbar background on scroll
  const nav = document.querySelector('nav');

  if (nav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        nav.classList.add('bg-gray-900/95', 'backdrop-blur-md');
        nav.classList.remove('bg-gray-900/90');
      } else {
        nav.classList.remove('bg-gray-900/95', 'backdrop-blur-md');
        nav.classList.add('bg-gray-900/90');
      }
    });
  }

  // Smooth scrolling for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');

      if (href !== '#') {
        e.preventDefault();

        const target = document.querySelector(href);
        if (target) {
          const offsetTop = target.offsetTop - 80;

          if (typeof gsap !== 'undefined') {
            gsap.to(window, {
              duration: 1,
              scrollTo: { y: offsetTop, autoKill: false },
              ease: 'power2.inOut'
            });
          } else {
            window.scrollTo({
              top: offsetTop,
              behavior: 'smooth'
            });
          }
        }
      }
    });
  });
}


function initPlatformSlider() {
  const track = document.querySelector('.platform-slider-track');
  const slides = document.querySelectorAll('.platform-slide');
  const nextBtn = document.querySelector('.platform-next-btn');
  const prevBtn = document.querySelector('.platform-prev-btn');
  const dots = document.querySelectorAll('.platform-dot');

  if (!track || slides.length === 0) return;

  let currentSlide = 0;
  const slideCount = slides.length;

  console.log('Platform slider initialized with', slideCount, 'slides');

  // Update slider position and active states
  function updateSlider() {
    // Move the track
    const translateX = -currentSlide * 100;
    track.style.transform = `translateX(${translateX}%)`;

    // Update dots
    dots.forEach((dot, index) => {
      if (index === currentSlide) {
        dot.classList.add('active', 'bg-blue-500');
        dot.classList.remove('bg-gray-600');
      } else {
        dot.classList.remove('active', 'bg-blue-500');
        dot.classList.add('bg-gray-600');
      }
    });

    // Update button states
    prevBtn.disabled = currentSlide === 0;
    nextBtn.disabled = currentSlide === slideCount - 1;

    // Add GSAP animations for slide transitions
    if (typeof gsap !== 'undefined') {
      // Animate content for the current slide
      gsap.fromTo(slides[currentSlide].querySelectorAll('.platform-text, .platform-image'),
        {
          opacity: 0,
          y: 30
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out'
        }
      );
    }
  }

  // Next slide
  function nextSlide() {
    if (currentSlide < slideCount - 1) {
      currentSlide++;
      updateSlider();
    }
  }

  // Previous slide
  function prevSlide() {
    if (currentSlide > 0) {
      currentSlide--;
      updateSlider();
    }
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      updateSlider();
    });
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    }
  });

  // Auto-advance (optional)
  // setInterval(nextSlide, 5000);

  // Initialize slider position
  updateSlider();

  // Add CSS for the active dot
  const style = document.createElement('style');
  style.textContent = `
        .platform-dot.active {
            background-color: rgb(59 130 246);
            transform: scale(1.2);
        }
    `;
  document.head.appendChild(style);
}

// Cookie Banner Initialization Logic
function initCookieBanner() {
  const banner = document.getElementById('cookie-banner');
  const acceptBtn = document.getElementById('cookie-accept');
  const declineBtn = document.getElementById('cookie-decline');

  // Safety check: if elements don't exist (e.g. HTML not updated), exit
  if (!banner || !acceptBtn || !declineBtn) return;

  // 1. Check if user already accepted or declined
  if (!localStorage.getItem('mineops_cookie_consent')) {
    // If no consent stored, show banner with a slight delay
    setTimeout(() => {
      banner.classList.remove('translate-y-full');
    }, 1000);
  }

  // 2. Action on Accept
  acceptBtn.addEventListener('click', () => {
    localStorage.setItem('mineops_cookie_consent', 'accepted');
    banner.classList.add('translate-y-full'); // Hide banner

    // Optional: Activate Google Analytics consent here if needed
    // window.dataLayer = window.dataLayer || [];
    // gtag('consent', 'update', {'analytics_storage': 'granted'});
  });

  // 3. Action on Decline
  declineBtn.addEventListener('click', () => {
    localStorage.setItem('mineops_cookie_consent', 'declined');
    banner.classList.add('translate-y-full'); // Hide banner
  });
}

// Helper function for form cooldown
function startFormCooldown(submitBtn, originalText, duration = 30) {
  let secondsRemaining = duration;
  submitBtn.disabled = true;
  submitBtn.textContent = `Wait ${secondsRemaining}s...`;

  const intervalId = setInterval(() => {
    secondsRemaining--;
    if (secondsRemaining > 0) {
      submitBtn.textContent = `Wait ${secondsRemaining}s...`;
    } else {
      clearInterval(intervalId);
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }
  }, 1000);
}

function getRecaptchaToken(action) {
  return new Promise((resolve, reject) => {
    // 1. Revisa si grecaptcha está cargado
    if (typeof grecaptcha === 'undefined' || typeof grecaptcha.ready === 'undefined') {
      return reject(new Error('reCAPTCHA script not loaded or blocked'));
    }

    // 2. Espera a que grecaptcha esté listo
    grecaptcha.ready(() => {
      try {
        // 3. Ejecuta y "promete" el token
        grecaptcha.execute('6LccvgcsAAAAABZy-K0Pclc1I80pH7zg04LvCJmZ', { action: action })
          .then(token => {
            if (!token) {
              reject(new Error('reCAPTCHA returned an empty token.'));
            }
            resolve(token);
          })
          .catch(err => {
            // Este .catch es para la promesa de execute()
            reject(new Error('reCAPTCHA execution failed: ' + err));
          });
      } catch (err) {
        // Este catch es por si grecaptcha.execute falla (ej. configuración)
        reject(new Error('reCAPTCHA.execute() threw an error: ' + err));
      }
    });
  });
}

// Form handling with webhook integration
function initForms() {
  // Waitlist form
  const waitlistForm = document.querySelector('.waitlist-form');
  const waitlistSuccess = document.querySelector('.waitlist-success');
  const waitlistError = document.querySelector('.waitlist-error');

  if (waitlistForm) {
    waitlistForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      // Check honeypot field
      const honeypot = this.querySelector('input[name="website"]');
      if (honeypot && honeypot.value) {
        console.log('Spam detected - honeypot field filled');
        return;
      }

      const emailInput = this.querySelector('input[type="email"]');
      const email = emailInput.value;

      if (email && isValidEmail(email)) {
        console.log('Waitlist submission:', email);

        // Show loading state
        const submitBtn = this.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Joining...';
        submitBtn.disabled = true;

        let isSuccess = false; // <-- 1. Añadir bandera

        try {

          const token = await getRecaptchaToken('submit_waitlist');

          const response = await fetch('https://hook.us2.make.com/v12w6r2fm49lpjjjout9otc5pcqbpjtx', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Secret-Key': 'k9$B@zR7pW!4mJ*sE#aV6nQ8'
            },
            body: JSON.stringify({
              email: email,
              source: 'waitlist',
              timestamp: new Date().toISOString(),
              recaptchaToken: token // <-- Ahora 'token' estará definido
            })
          });

          if (response.ok) {
            isSuccess = true; // <-- 2. Marcar éxito
            // Show success message
            if (waitlistSuccess) {
              waitlistSuccess.classList.remove('hidden');
              this.reset();

              if (typeof gsap !== 'undefined') {
                gsap.fromTo(waitlistSuccess,
                  { y: 20, opacity: 0 },
                  { y: 0, opacity: 1, duration: 0.5, ease: 'back.out(1.7)' }
                );
              }

              setTimeout(() => {
                if (typeof gsap !== 'undefined') {
                  gsap.to(waitlistSuccess, {
                    y: -20,
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.in',
                    onComplete: () => {
                      waitlistSuccess.classList.add('hidden');
                    }
                  });
                } else {
                  waitlistSuccess.classList.add('hidden');
                }
              }, 5000);
            }
            // 3. Iniciar cooldown
            startFormCooldown(submitBtn, originalText, 30);
          } else {
            throw new Error('Network response was not ok');
          }
        } catch (error) {
          // Este 'catch' ahora SÍ atrapará el error de reCAPTCHA
          console.error('Error submitting waitlist:', error);
          // Show error message
          if (waitlistError) {
            waitlistError.classList.remove('hidden');
            setTimeout(() => {
              waitlistError.classList.add('hidden');
            }, 5000);
          }
        } finally {
          // 4. Modificar bloque finally
          if (!isSuccess) {
            // Solo reactivar si NO hubo éxito (ej. un error)
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        }
      } else {
        // Invalid email animation
        if (typeof gsap !== 'undefined' && emailInput) {
          gsap.to(emailInput, {
            x: 10,
            duration: 0.1,
            repeat: 5,
            yoyo: true,
            ease: 'power1.inOut'
          });
        }
        alert('Please enter a valid email address.');
      }
    });
  }

  // Contact form
  const contactForm = document.getElementById('contactForm');
  const contactSuccess = document.getElementById('contact-success');
  const contactError = document.getElementById('contact-error');

  if (contactForm) {
    contactForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      // Check honeypot field
      const honeypot = this.querySelector('input[name="honeypot"]');
      if (honeypot && honeypot.value) {
        console.log('Spam detected - honeypot field filled');
        return;
      }

      const name = document.getElementById('name').value;
      const email = document.getElementById('email').value;

      if (!name || !email) {
        const invalidFields = [];
        if (!name) invalidFields.push(document.getElementById('name'));
        if (!email) invalidFields.push(document.getElementById('email'));

        if (typeof gsap !== 'undefined') {
          invalidFields.forEach(field => {
            gsap.to(field, {
              x: 10,
              duration: 0.1,
              repeat: 5,
              yoyo: true,
              ease: 'power1.inOut'
            });
          });
        }
        alert('Please fill in all required fields.');
        return;
      }

      if (!isValidEmail(email)) {
        if (typeof gsap !== 'undefined') {
          gsap.to(document.getElementById('email'), {
            x: 10,
            duration: 0.1,
            repeat: 5,
            yoyo: true,
            ease: 'power1.inOut'
          });
        }
        alert('Please enter a valid email address.');
        return;
      }

      // Show loading state
      const submitBtn = this.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;

      let isSuccess = false; // <-- 1. Añadir bandera

      // Hide any previous messages
      if (contactSuccess) contactSuccess.classList.add('hidden');
      if (contactError) contactError.classList.add('hidden');

      try {
        const formData = {
          name: name,
          email: email,
          company: document.getElementById('company').value,
          miners: document.getElementById('miners').value,
          message: document.getElementById('message').value,
          source: 'contact',
          timestamp: new Date().toISOString()
        };

        console.log('Contact form submission:', formData);


        const token = await getRecaptchaToken('submit_contact');

        const response = await fetch('https://hook.us2.make.com/45xc1nn6wbdhf8xkwk829qfmsr7ebmwu', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Secret-Key': 'k9$B@zR7pW!4mJ*sE#aV6nQ8'
          },
          body: JSON.stringify({
            ...formData, // El ...formData expande los datos del formulario
            recaptchaToken: token // <-- Ahora 'token' estará definido
          })
        });

        if (response.ok) {
          isSuccess = true; // <-- 2. Marcar éxito
          // Show success message
          if (contactSuccess) {
            contactSuccess.classList.remove('hidden');
            if (typeof gsap !== 'undefined') {
              gsap.fromTo(contactSuccess,
                { y: 20, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.5, ease: 'back.out(1.7)' }
              );
            }
          }

          // Reset form
          this.reset();

          // 3. Iniciar cooldown
          startFormCooldown(submitBtn, originalText, 30);
        } else {
          throw new Error('Network response was not ok');
        }
      } catch (error) {
        // Este 'catch' ahora SÍ atrapará el error de reCAPTCHA
        console.error('Error submitting contact form:', error);
        // Show error message
        if (contactError) {
          contactError.classList.remove('hidden');
          if (typeof gsap !== 'undefined') {
            gsap.fromTo(contactError,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.5, ease: 'back.out(1.7)' }
            );
          }
        }
      } finally {
        // 4. Modificar bloque finally
        if (!isSuccess) {
          // Solo reactivar si NO hubo éxito (ej. un error)
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }
      }
    });
  }
}

export { initCarousel, initFAQ, initForms, initAnimations, initParticles, initScrollEffects, initPlatformSlider, initCookieBanner };